import { useEffect, useRef } from 'react';

import { useSelector } from 'react-redux';
import * as dealTemplateSelectors from '@makemydeal/dr-dash-store/selectors/dealTemplateSelectors';
import { useToastDisappear } from '../../../../common/DataLoadingToast';
import { TOAST_TIMEOUT } from '@interstate/components/Toast/Toast/store';

export const useRecentlyRemovedTemplate = () => {
    const isRemoving = useSelector(dealTemplateSelectors.getIsDealTemplateRemoving);
    const isRemoved = useSelector(dealTemplateSelectors.getIsDealTemplateRemoved);
    const isRemovingError = useSelector(dealTemplateSelectors.getIsDealTemplateRemovingError);
    const templateName = useSelector(dealTemplateSelectors.getDealTemplateRemovingName);
    const inventoryType = useSelector(dealTemplateSelectors.getDealTemplateRemovingInventoryType);
    const { toastShown, triggerToast } = useToastDisappear(TOAST_TIMEOUT);

    const wasRemovingRef = useRef(false);
    useEffect(() => {
        if (isRemoving) {
            wasRemovingRef.current = true;
        }
    }, [isRemoving]);

    useEffect(() => {
        if (!wasRemovingRef.current) return;
        if (isRemoved || isRemovingError) {
            wasRemovingRef.current = false;
            triggerToast();
        }
    }, [isRemoved, isRemovingError]);

    return {
        shouldShowSuccessToast: Boolean(toastShown && isRemoved && templateName),
        shouldShowErrorToast: Boolean(toastShown && isRemovingError && templateName),
        templateName,
        isRemoving,
        inventoryType,
        isRemoved
    };
};
